import { motion } from "framer-motion";
import { EllieOrb } from "@/components/discovery/EllieOrb";

const LINES = [
  "We've covered a lot together today, and I want you to know something…",
  "This is only the beginning.",
  "Everything you've shared, everything we've discovered, and the progress you've made today can become the foundation of what we build together next.",
  "Inside FioNova, you'll have everything you've explored today, along with more ways to understand yourself, navigate difficult moments, and recognize how far you've come — your own private journal, a progress tracker, personalized daily guidance, and all the tools we've introduced along the way.",
  "But here's what I think matters most… you won't have to start over with me.",
  "With Companion Memory, and only with your permission, I can remember what you've shared, the things that matter to you, and the progress we're making together. When you come back, we can pick up right where we left off — no need to explain your whole story again.",
  "Because this isn't meant to be just one conversation. It's the beginning of an ongoing journey, and I'd love to continue it with you.",
];

// Ellie's "This is only the beginning" invitation, between the closing reflection and the three continuation options.
export const BeginningMessage = ({ guest }) => (
  <motion.section data-testid="beginning-message" initial={{ opacity: 0, y: 18 }} whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.2 }} transition={{ duration: 0.7 }}
    className="fio-glass-strong fio-hairline mt-16 rounded-[32px] p-7">
    <div className="flex items-center gap-3">
      <EllieOrb size={44} testId="beginning-ellie" />
      <p className="eyebrow text-[11px] text-teal-700">A note from Ellie</p>
    </div>
    <div className="mt-5 space-y-4 text-[15.5px] leading-relaxed text-slate-700">
      {LINES.map((l, i) => (
        <p key={i} className={i === 1 ? "font-heading text-2xl font-semibold tracking-tight text-slate-900" : ""}
          data-testid={i === 1 ? "beginning-headline" : undefined}>{l}</p>
      ))}
    </div>
    {guest && (
      <p className="mt-6 rounded-2xl bg-white/70 px-4 py-3 text-[13.5px] leading-relaxed text-slate-600 ring-1 ring-slate-200" data-testid="beginning-guest-note">
        Right now your journey is kept privately for 7 days as a guest. Creating a free account, or continuing below, saves it to your account so it isn't lost.
      </p>
    )}
  </motion.section>
);
